import { string, instanceOf, object, oneOfType } from 'prop-types';
import styled from 'styled-components/macro';

import modularScale from 'styles/helpers/modular-scale';

const Summary = styled('p')`
  cursor: default;
  color: ${({ theme }) => theme.CasperGrey};
`;

const ErrorInfo = styled('p')`
  font-size: ${modularScale(-1)};
`;

const Details = styled('div')`
  font-size: ${modularScale(-1)};
  color: ${({ theme }) => theme.CasperGrey};

  pre {
    text-align: left;
  }

  @media screen and (min-width: 40rem) {
    font-size: ${modularScale(0)};
  }
`;

/**
 * Extracts the relevant information from errorInfo.
 *
 * @param {object} errorInfo
 * @returns {string}
 */
const renderErrorInfo = (errorInfo) => {
  // Errors thrown in React.Component include a componentStack
  if (errorInfo.componentStack) {
    return errorInfo.componentStack;
  }

  // withFetch reports the headers fetch used as errorInfo
  if (errorInfo instanceof Headers) {
    let headers = '';

    for (const pair of errorInfo.entries()) {
      headers = headers + `${pair[0]}: ${pair[1]}\n`;
    }

    return headers;
  }

  if (typeof errorInfo !== 'string') {
    return JSON.stringify(errorInfo);
  }

  return errorInfo;
};

/** Displays error details on an error page or boundary */
const ErrorDetails = ({ error, errorInfo }) => {
  return (
    <div>
      <Details>
        <Summary>Error details</Summary>
        {error && <ErrorInfo>{error.toString()}</ErrorInfo>}
        {errorInfo && <ErrorInfo>{renderErrorInfo(errorInfo)}</ErrorInfo>}
      </Details>
    </div>
  );
};

export default ErrorDetails;

ErrorDetails.propTypes = {
  /** An instance of the native Error object */
  error: instanceOf(Error).isRequired,
  /** An object with additional error information, like a stack trace, or request headers. */
  errorInfo: oneOfType([object, string]),
};
